import type { OrganizationSettings } from '../models';

export const DEFAULT_ORGANIZATION_SETTINGS: OrganizationSettings = {
  billingMode: 'paid',
  allowedDomains: [],
  invitesEnabled: true,
  clientInvitesEnabled: true,
  inviteExpiryDays: 7,
  booking: {
    clientBookingEnabled: true,
    showAllVehiclesToClients: true,
    cancellationCutoffHours: 24,
    requiresApproval: false,
    bookingWindowStartDays: 0,
    bookingWindowEndDays: 60,
  },
  notifications: {
    bookingEmails: true,
    managerDigest: 'instant',
  },
};

export function mergeOrganizationSettings(
  settings?: Partial<OrganizationSettings> | null
): OrganizationSettings {
  return {
    ...DEFAULT_ORGANIZATION_SETTINGS,
    ...settings,
    allowedDomains: settings?.allowedDomains
      ? [...settings.allowedDomains]
      : [...DEFAULT_ORGANIZATION_SETTINGS.allowedDomains],
    booking: {
      ...DEFAULT_ORGANIZATION_SETTINGS.booking,
      ...(settings?.booking ?? {}),
    },
    notifications: {
      ...DEFAULT_ORGANIZATION_SETTINGS.notifications,
      ...(settings?.notifications ?? {}),
    },
  };
}
